import { Breakpoints } from '@/lib/breakpoints';
import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { TextColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    footer: {
      width: '100%',
      padding: `${Spacings.s40} 0`,
      fontSize: FontSizes.t4,
      color: TextColors.base,
    },
    inner: {
      margin: '0 auto',
      display: 'flex',
      maxWidth: 1280,
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s24,
      padding: `0 ${Spacings.s24}`,
      textAlign: 'center',
    },
    list: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: Spacings.s24,
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    link: {
      display: 'inline-flex',
      height: 16,
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.t3,
      color: TextColors.tint2,
      transition: 'color 200ms',
      textDecoration: 'none',
      '&:hover': { color: TextColors.base },
    },
    privacyChoices: {
      display: 'inline-flex',
      height: 16,
      alignItems: 'center',
      gap: Spacings.s4,
      padding: 0,
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      fontFamily: 'inherit',
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.t3,
      color: TextColors.tint2,
      transition: 'color 200ms',
      '&:hover': { color: TextColors.base },
    },
    privacyChoicesIcon: { display: 'block', flexShrink: 0 },
    copyright: {
      fontSize: FontSizes.t3,
      color: TextColors.tint2,
      [Breakpoints.SM]: { fontSize: FontSizes.t4 },
    },
  },
  { name: 'footer' },
);

export default useStyles;
